import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { OrderCard } from "@/components/OrderCard";

export default function MyOrders() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [orders, setOrders] = useState(null);
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    if (user === false) navigate("/login");
  }, [user, navigate]);

  useEffect(() => {
    if (user) {
      api.get("/my-orders").then((r) => setOrders(r.data)).catch(() => setOrders([]));
      api.get("/brands").then((r) => setBrands(r.data)).catch(() => {});
    }
  }, [user]);

  if (!user) return null;

  return (
    <main data-testid="my-orders-page">
      <Navbar />
      <section className="pt-32 md:pt-40 pb-24 min-h-screen">
        <div className="max-w-[1200px] mx-auto px-6 md:px-12">
          <p className="text-xs uppercase tracking-[0.5em] text-gold mb-4">My Orders</p>
          <h1 className="font-serif font-medium text-4xl sm:text-5xl text-zinc-900 tracking-tight mb-14">
            Every order, <em className="text-gold">tracked</em>.
          </h1>
          {orders === null ? (
            <p className="text-zinc-400 text-xs uppercase tracking-[0.4em]">Loading…</p>
          ) : orders.length === 0 ? (
            <div className="text-center py-24" data-testid="orders-empty">
              <p className="font-serif italic text-3xl text-zinc-400">No orders yet.</p>
              <Link to="/shop" className="inline-block mt-8 bg-gold text-white text-xs uppercase tracking-[0.3em] px-10 py-4 hover:bg-champagne transition-colors duration-300">
                Start Shopping
              </Link>
            </div>
          ) : (
            <div className="space-y-6">
              {orders.map((o) => <OrderCard key={o.id} o={o} />)}
            </div>
          )}
        </div>
      </section>
      <Footer brands={brands} />
    </main>
  );
}
